import { _ } from '../third-party';
import { VOLUME_EPS } from '../constants/common';
import { APIOrdersListParams } from '../types/api';

export type VolumeFilterMap = Record<string, boolean>;

export const composeVolumeParams = (
  volumeFilter: VolumeFilterMap,
): APIOrdersListParams['volume'] => {
  const volume: APIOrdersListParams['volume'] = [];

  _.forOwn(volumeFilter, (checked, range) => {
    if (!checked) return;

    const [from, to] = range.split('-');
    const parsedFrom = parseInt(from, 10);
    const parsedTo = parseInt(to, 10);

    const rawFrom = Number.isNaN(parsedFrom) ? null : parsedFrom;
    const rawTo = Number.isNaN(parsedTo) ? null : parsedTo;

    let volumeFrom: number | null = null;
    if (rawFrom !== null) {
      volumeFrom = rawFrom === 0 ? 0 : rawFrom + 1;
    }

    const volumeTo = rawTo === null ? null : rawTo + (1 - VOLUME_EPS);

    if (volumeFrom !== null || volumeTo !== null) {
      volume.push({
        ...(volumeFrom !== null ? { from: volumeFrom } : {}),
        ...(volumeTo !== null ? { to: volumeTo } : {}),
      });
    }
  });

  return volume;
};
